import React from 'react'


const NewAllocationItemInput = ({input}) => {
  let inputData = { 
    name: input.name,
    className: 'onsched-dark-color',
    required: input.required
  }

  if (input.type) inputData.type = input.type;
  if (input.defaultValue) inputData.defaultValue = input.defaultValue;
  
  let children = input.children
                  ? 
                 input.children.map(time => (<option key={time.value} value={time.value}>{time.displayTime}</option>))
                  : 
                 null

  return React.createElement(
    input.component,
    inputData,
    children
  )
}

export default NewAllocationItemInput